import type { ReactElement } from 'react';
import type { WellRegionCount } from '../../domain/types';

interface WellRegionTilesProps {
  regions: WellRegionCount[];
  selectedRegion: string | null;
  onSelectRegion: (region: string | null) => void;
}

export function WellRegionTiles({ regions, selectedRegion, onSelectRegion }: WellRegionTilesProps): ReactElement {
  const total = regions.reduce((s, r) => s + r.count, 0);

  return (
    <section className="tiles-grid wells-region-tiles" aria-label="Wells by region" data-testid="wells-tiles">
      <article
        className={`tile ${selectedRegion === null ? 'tile-active' : ''}`}
        onClick={() => onSelectRegion(null)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelectRegion(null);
          }
        }}
      >
        <h3>All regions</h3>
        <p>{total}</p>
      </article>
      {regions.map((r) => (
        <article
          key={r.region}
          className={`tile ${selectedRegion === r.region ? 'tile-active' : ''}`}
          onClick={() => onSelectRegion(r.region)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onSelectRegion(r.region);
            }
          }}
        >
          <h3 title={r.region}>{r.region}</h3>
          <p>{r.count}</p>
        </article>
      ))}
    </section>
  );
}
